import * as React from 'react';

import * as results from './results.module.scss';
import * as main from '../../../styles/mainOld.module.scss';

export const ResultsOld = () => {
  return (
    <section className={results.results} id="results">
      <div className="container">
        <div className={`row ${results.results__row}`}>
          <div className={`col-12 col-md-6 ${results.results__col}`}>
            <h2 className={`${results.results__title} ${results.results__titleDesktop} ${main.mainTitle}`}>
              Результат курса&nbsp;— навыки для учебы и&nbsp;жизни
            </h2>
            <div className={results.results__img}></div>
            <div
              className={`${results.results__wrapper} ${results.results__wrapperBorder} ${results.results__wrapperSpecial}`}
            >
              <h3 className={results.results__subtitle}>Самостоятельность</h3>
              <p className={results.results__text}>
                В курсе есть целый блок, который научит ребенка самостоятельно учиться. В дальнейшем это позволит стать
                самодостаточным человеком.
              </p>
            </div>
          </div>
          <div className={`col-12 col-md-6 ${results.results__col}`}>
            <h2 className={`${results.results__title} ${results.results__titleMobile} ${main.mainTitle}`}>
              Результат курса&nbsp;— навыки для учебы и&nbsp;жизни
            </h2>
          </div>
          <div className={`col-12 col-md-6 ${results.results__col}`}>
            <div className={`${results.results__wrapper} ${results.results__wrapperBorder}`}>
              <h3 className={results.results__subtitle}>Концентрация внимания</h3>
              <p className={results.results__text}>
                Среднестатистический взрослый человек может сконцентрироваться не&nbsp;дольше 6&nbsp;минут. После курса
                ребенок сможет сосредотачиваться на&nbsp;период от&nbsp;1 до&nbsp;5&nbsp;часов.
              </p>
            </div>
          </div>
          <div className={`col-12 col-md-6 ${results.results__col}`}>
            <div className={`${results.results__wrapper} ${results.results__wrapperBorder}`}>
              <h3 className={results.results__subtitle}>Усидчивость и&nbsp;мотивация</h3>
              <p className={results.results__text}>
                Учиться станет легче, и&nbsp;ребенок увидит результаты. Это позволит увеличить интерес к&nbsp;учебе.
              </p>
            </div>
          </div>
          <div className={`col-12 col-md-6 ${results.results__col}`}>
            <div className={`${results.results__wrapper} ${results.results__wrapperBorderMobile}`}>
              <h3 className={results.results__subtitle}>Долгосрочное запоминание</h3>
              <p className={results.results__text}>
                Специальные техники запоминания помогут закрепить знания в&nbsp;долгосрочной памяти
                и&nbsp;воспроизводить их по&nbsp;желанию.
              </p>
            </div>
          </div>
          <div className={`col-12 col-md-6 ${results.results__col}`}>
            <div className={results.results__wrapper}>
              <h3 className={results.results__subtitle}>Быстрое освоение предмета</h3>
              <p className={results.results__text}>
                Курс дает сразу несколько технологий ускоренного обучения. Усвоив их, ребенок сможет проходить учебник
                за&nbsp;4-5&nbsp;дней.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
